// ─────────────────────────────────────────────────────────────────────────────
// MANUAL Filipino overrides — these ALWAYS win over the auto-generated cache.
//
// Use this when an estimator wants a specific wording the machine translation
// got wrong or awkward. Key = the exact English text; value = the Filipino you
// want. `npm run i18n` never touches this file.
//
//   export const OVERRIDES_FIL: Record<string, string> = {
//     'New Bid': 'Bagong Bid',
//     'Sign out': 'Mag-logout',
//   };
// ─────────────────────────────────────────────────────────────────────────────

export const OVERRIDES_FIL: Record<string, string> = {
  // Add corrections here, e.g.:
  // 'Dashboard': 'Dashboard',
};
